import { detailsQueries } from 'src/common/components/Sim/Details/queries/detailsQueries';

type RSimProductsDetailProps = {
  euicc: string;
};

type RSimProductsDetailProfileProps = {
  euicc: string;
  iccid?: string;
};

const allRsimProductDetailsQueries = [...detailsQueries.details, 'RSimProductDetails'];
export const rsimProductDetailsQueries = {
  all: allRsimProductDetailsQueries,
  allDetails: [...allRsimProductDetailsQueries, 'details'],
  detail: (props: RSimProductsDetailProps) => [...rsimProductDetailsQueries.allDetails, props],
  profile: ({ euicc, ...props }: RSimProductsDetailProfileProps) => [
    ...rsimProductDetailsQueries.detail({ euicc }),
    'profile',
    props,
  ],
  location: ({ euicc }: RSimProductsDetailProps) => [
    ...rsimProductDetailsQueries.detail({ euicc }),
    'location',
  ],
  lastPolling: (euicc: string) => [
    ...rsimProductDetailsQueries.all,
    'RSimProductDetailPooling',
    { euicc },
  ],
};
